var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-row', [_vm._l(_vm.products, function (product) {
    return [_c('v-col', {
      key: product._id,
      attrs: {
        "cols": "6",
        "sm": "4",
        "md": "3"
      }
    }, [_vm._t("list-item", null, {
      "product": product
    })], 2)];
  })], 2), _c('div', {
    staticClass: "mt-30px mt-md-40px"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('input', _vm.page);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }